<template>
  <div class="Home">
    
    <div class="wrapper">
      <div class="intro">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide>
            <h1>
              Mike Cassie.<br>
              Product Designer &amp; Leader.
            </h1>
          </swiper-slide>
          <swiper-slide>
            <h2>
              Over 20 years experience across hundreds of projects and dozens of brands.
            </h2>
          </swiper-slide>
          <swiper-slide>
            <h2>
              Design, strategy, leadership &amp; project management.
            </h2>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <span class="desktop">
          <h1>
            Mike Cassie.<br>
            Product Designer and Leader.
          </h1>
          <h2>
            Over 20 years experience across hundreds of projects and dozens of brands.
          </h2>
          <h2>
            Design, strategy, leadership &amp; project management.
          </h2>
        </span>
      </div>
      <div class="homeBG"></div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Home',
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  directives: {
    swiper: directive
  },
  beforeCreate() {
    store.commit('isHome', true)
  },
  destroyed() {
    store.commit('isHome', false)
  }
}
</script>

<style lang="scss" scoped>
  .Home {
    & .homeBG {
      position: fixed;
      background-image: url("/assets/ui/home-bg.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position-x: 20%;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    & .wrapper {
      @include siteWrapper;
      position: relative;

      & .intro {
        width: 550px;
        padding: 15% 0 10% 0;
        position: relative;
        z-index: 3;

        & .desktop {
          @media screen and (max-width: $breakSmall) {
            display: none;
          }
        }

        & h1 {
          font-size: 58px;
          line-height: 78px;
          margin: 0 0 80px 0;
        }
        & h2 {
          font-size: 42px;
          line-height: 60px;
          margin: 0 0 40px 0;
        }
      }
    }
    @media screen and (max-width: $breakWide) {
      & .homeBG {
        background-position-x: 30%;
      }

      & .wrapper {
        & .intro {
          width: 500px;
          padding: 20% 0 10% 0;

          & h1 {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 70px 0;
          }
          & h2 {
            font-size: 36px;
            line-height: 54px;
            margin: 0 0 30px 0;
          }
        }
      }
    }
    @media screen and (max-width: $breakLarge) {
      & .wrapper {

        & .intro {
          width: 450px;
          padding: 20% 0 10% 0;

          & h1 {
            font-size: 46px;
            line-height: 66px;
            margin: 0 0 70px 0;
          }
          & h2 {
            font-size: 32px;
            line-height: 50px;
            margin: 0 0 30px 0;
          }
        }
      }
    }
    @media screen and (max-width: $breakSmall) {
      // & .homeBG {
      //   background-position: center top;
      //   background-image: url("/assets/ui/home-bg-mobile.jpg");
      //   background-size: cover;
      // }

      // & .wrapper {
      //   margin: 0;
      //   width: 100%;

      //   & .intro {
      //     width: 100%;
      //     position: fixed;
      //     top: 100px;
      //     left: 0;
      //     right: 0;
      //     text-align: center;
      //     margin: 0;
      //     padding: 0;

      //     & h1 {
      //       font-size: 32px;
      //       line-height: 44px;
      //       margin: 0 auto;
      //       padding: 0 0 45px 0;
      //       width: calc(100% - 60px);
      //     }
      //     & h2 {
      //       font-size: 25px;
      //       line-height: 34px;
      //       margin: 0 auto;
      //       width: calc(100% - 80px);
      //     }
      //   }
      // }
    }


    @media screen and (max-width: $breakSmall) {
      height: 100%;
      background: #f4f4f4;
      
      & .homeBG {
        position: fixed;
        background-position: center top;
        background-image: url("/assets/ui/home-bg-mobile-small.jpg");
        background-size: cover;
        top: 250px;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
      }

      & .wrapper {
        margin: 0;
        width: 100%;
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        & .intro {
          width: 100%;
          position: relative;
          top: auto;
          left: auto;
          right: auto;
          text-align: center;
          margin: auto;
          padding: 100px 0 0 0;

          & h1 {
            font-size: 32px;
            line-height: 44px;
            margin: 0 auto;
            padding: 0 0 45px 0;
            width: calc(100% - 60px);
          }
          & h2 {
            font-size: 25px;
            line-height: 34px;
            margin: 0 auto;
            width: calc(100% - 80px);
          }
        }
      }
    }



    @media screen and (max-width: 360px) {
      & .homeBG {
        top: 230px;
      }

      & .wrapper {

        & .intro {
          padding: 90px 0 0 0;

          & h1 {
            font-size: 26px;
            line-height: 38px;
            padding: 0 0 40px 0;
            width: calc(100% - 60px);
          }
          & h2 {
            font-size: 20px;
            line-height: 30px;
            width: calc(100% - 60px);
          }
        }
      }
    }
  }
</style>
